import React from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default function StaticPage({ title, kicker, children, openChat }) {
  return (
    <div className="min-h-screen relative" data-testid="static-page">
      <Nav onOpenChat={openChat} />
      <div className="relative pt-36 pb-24 px-6">
        <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />
        <div className="relative max-w-4xl mx-auto">
          {kicker && <p className="font-mono text-[11px] tracking-[0.4em] text-cyan-300/80 mb-3" data-testid="page-kicker">◆ {kicker}</p>}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-[Outfit] font-bold leading-tight" data-testid="page-title">
            {title}
          </h1>
          <div className="mt-8 space-y-5 text-white/75 leading-relaxed text-[15px]">
            {children}
          </div>
          <div className="mt-12 flex flex-wrap gap-3">
            <Link to="/" className="btn-ghost rounded-full px-6 py-2.5 text-sm" data-testid="back-home-link">← Back to home</Link>
            <Link to="/#contact" className="btn-gradient rounded-full px-6 py-2.5 text-sm">Talk to MUNNEXA →</Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
